'use client';
import styled from 'styled-components';
import { Name } from '@web/molecules/ProductCardCRO/styles';

export const StyledRecommendedPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
    min-width: unset;
  }
  legend {
    ${({ theme }) => theme.typography.heading5}
    margin: 0 auto ${({ theme }) => theme.spacing(5)};
  }

  @media ${props => props.theme.laptop} {
    flex-direction: row;
  }
`;

export const StyledForm = styled.form`
  padding-bottom: ${props => props.theme.spacing(29)};
  width: 100vw;
`;

export const HeaderContainer = styled.div`
  position: relative;
  top: 0;
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing(5)};
  padding: ${({ theme }) => theme.spacing(4, 2, 2)};
  color: ${({ theme }) => theme.colors.text.primary};

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(5, 0, 0)};
  }
`;

export const FullHeadline = styled.h1`
  ${({ theme }) => theme.typography.heading3}

  @media ${props => props.theme.laptop} {
    ${({ theme }) => theme.typography.heading2}
  }
`;

export const FullSubheadline = styled.p`
  ${({ theme }) => theme.typography.body};
  margin: ${({ theme }) => theme.spacing(2)} auto 0;
  padding: ${({ theme }) => theme.spacing(0, 2, 4)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};

  button {
    text-decoration: underline;
    ${({ theme }) => theme.typography.body};
  }

  @media ${props => props.theme.laptop} {
    width: 85%;
  }
`;

export const ProductSelectorContainerDesktop = styled.div`
  display: none;

  @media ${({ theme }) => theme.laptop} {
    display: block;
  }
`;

export const ProductSelectorContainerMobile = styled.div`
  display: block;
  @media ${({ theme }) => theme.laptop} {
    display: none;
  }
`;

export const ProductCardContainer = styled.div`
  max-width: 100%;
  margin: auto;
  text-align: center;
  padding-bottom: ${props => (props.paddingBottom ? '50px' : 0)};
  @media ${({ theme }) => theme.laptop} {
    margin: 0;
  }
`;

export const PlanContainer = styled.div`
  ${props => props.theme.typography.heading4};
  margin-top: ${props => props.theme.spacing(3)};
  padding-bottom: ${props => props.theme.spacing(10)};

  @media ${({ theme }) => theme.tablet} {
    margin-top: ${props => props.theme.spacing(5)};
  }

  ${Name} {
    ${({ theme }) => theme.typography.heading4}
  }
`;

export const SectionHeader = styled.h5`
  ${props => props.theme.typography.heading5};
  padding: ${props => props.theme.spacing(5, 0)};
`;

export const DesktopImageContainer = styled.div`
  display: none;
  width: 50vw;
  height: auto;
  @media ${props => props.theme.laptop} {
    display: flex;
    img {
      min-height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }
`;

export const ContentContainer = styled.div`
  text-align: center;
  margin: 0 auto;

  @media ${props => props.theme.laptop} {
    padding: 0 ${props => props.theme.spacing(13)};
  }
`;

export const ButtonContainer = styled.div`
  z-index: 101;
  display: flex;
  position: fixed;
  top: 10px;
  left: 10px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: auto;
  button {
    border: none;
  }
  @media ${props => props.theme.laptop} {
    top: 10px;
    margin-bottom: ${props => props.theme.spacing(2)};
  }
`;
